__turbopack_context__.v({
  "BlogGrid": "BlogGrid-module-sass-module__vrFq4q__BlogGrid",
  "Cont": "BlogGrid-module-sass-module__vrFq4q__Cont",
  "FeaturePost": "BlogGrid-module-sass-module__vrFq4q__FeaturePost",
  "NoPosts": "BlogGrid-module-sass-module__vrFq4q__NoPosts",
  "Posts": "BlogGrid-module-sass-module__vrFq4q__Posts",
  "ShowMore": "BlogGrid-module-sass-module__vrFq4q__ShowMore",
});
